import React from 'react'
import { Button } from '@components/base'
import { App } from '@src/config'

export interface SkipButtonProps {
  title: string
  onPress: () => void
  testID?: string
}

export const SkipButton = (props: SkipButtonProps) => {
  const { title, onPress, testID } = props

  return (
    <Button
      type="transparent"
      size="block"
      testID={testID}
      onPress={onPress}
      accessibilityLabel={title}
    >
      {title + (App.build.production ? '' : ' [Debug]')}
    </Button>
  )
}
